import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from '../services/auth/auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {
	constructor(
		private authService: AuthService,
		private router: Router
	) {
	}

	canActivate(): boolean {
		if (this.authService.isAuthenticated()) {
			// Get the current language from the URL if it exists
			const currentUrl = this.router.url;
			const langMatch = currentUrl.match(/^\/([a-z]{2})\//);
			const langPrefix = langMatch ? `/${langMatch[1]}` : '';

			// Navigate to mobility with the correct language prefix
			this.router.navigate([`${langPrefix}/app/mobility`]);
			return false;
		}
		return true;
	}
}
